import { useCountriesAndLanguages } from "@made-people/grease-countries-and-languages";
import { ComponentWrapper } from "@made-people/blueprint-component-wrapper";
import { useTranslate } from "@made-people/grease-translations";

export const SizeGuideCalculator = () => {
  const { currentCountryCode, currentLanguageCode } =
    useCountriesAndLanguages();
  const translate = useTranslate();

  return (
    <ComponentWrapper
      theme={{ background: "white" }}
      layout={{ position: { maxWidth: "xl" } }}
    >
      <iframe
        src={`https://sizeguide.missmary.com/?chart=${currentCountryCode.toLowerCase()}&lang=${currentLanguageCode}`}
        className="w-full min-h-[800px]"
        title={translate("Size_Guide_Calculator_Title")}
      />
    </ComponentWrapper>
  );
};
